import React from 'react';
import { Button, Icon, Table, Form, Header, Segment, Popup, Loader, Input } from 'semantic-ui-react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';

import { IconHeader, FiltersOnStyle } from '../../Professor/ProfessorInputGrades/css';
import StudyProgramsFilter from '../StudentEnroll/StudyProgramsFilter';
import { ExportReactCSV } from '../../util/ExportCSV';
import SearchTableData from '../../util/SearchTableData';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema smjera (studijskog programa).</p>;
const NoDataMessage = () => <p>Nema smjera (studijskih programa).</p>;


export default class StudentSPEnroll extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            studyPrograms: [],
            indexNumber: '',
            studentStudyProgramId: '',

            sProgramId: null,

            loading: true,

            addIndexMode: false,
            indexNumberErr: false,

            confirmation: false,
            yes: false,

            results: []
        };

        this.getDataToRender = this.getDataToRender.bind(this);
        this.getStudyPrograms = this.getStudyPrograms.bind(this);
        this.enrollStudent = this.enrollStudent.bind(this);
        this.addIndex = this.addIndex.bind(this);
        this.getResults = this.getResults.bind(this);
    }

    componentDidMount() {
        this.getStudyPrograms();
    }

    enrollStudent(sProgramId, index) {
        this.setState({  sProgramId, confirmation: false, addIndexMode: index });

    }

    addIndex() {
        const { indexNumber } = this.state;
        if (!indexNumber) {
            this.setState({ indexNumberErr: true });
            toast('Morate unijeti broj indexa!');
        } else {

            let obj = {
                studentId: this.props.location.state.student.id,
                studyProgramId: this.state.sProgramId
            };

            axios.post('students/study-program-enroll', { ...obj })
                .then(res => {
                    this.setState({ studentStudyProgramId: res.data.id });
                    toast('Student je uspješno upisan na smjer (studijski program).');

                    this.setState({ indexNumberErr: false });
                    let obj = {
                        studentStudyProgram: { id: this.state.studentStudyProgramId },
                        number: this.state.indexNumber
                    };
                    axios.post('students/add-identification-document', { ...obj })
                        .then(res1 => {
                            toast('Studentu je uspješno dodijenjen broj indexa.');
                            this.setState({ addIndexMode: false });
                            this.getStudyPrograms();
                        })
                        .catch(err => {
                            toast('Došlo je do greške! Studentu nije dodijenjen broj indexa.');
                        });
                })
                .catch(err => {
                    toast('Došlo je do greške! Student nije upisan na smjer (studijski program).');
                    this.setState({ confirmation: false });
                });

        }
    }

    getStudyPrograms() {
        let obj = {};
        axios.post(`students/study-programs/not-enrolled-in/${this.props.location.state.student.id}`, { ...obj })
            .then(res => {
                const studyPrograms = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.departments ? el.departments.length ? el.departments[0].name + ' | ' + el.name + ' | ' + el.studyCycles[0].name : el.name + ' | ' + el.studyCycles[0].name : el.name + ' | ' + el.studyCycles[0].name
                }));
                this.setState({
                    data: res.data.map(el => ({
                        ...el, department: el.departments.length ? el.departments[0].name : ''
                    })),
                    studyPrograms,
                    loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch study programs');
            });
    }

    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        return this.state.data;
    }

    getResults(results) {
        this.setState({ results });
    }


    render() {
        if (this.state.loading) return <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>;
        return (
            <div>
                <h1>Upis na studijski program</h1>
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">{this.props.location.state.student.firstName} {this.props.location.state.student.lastName}
                            <Header.Subheader>
                                Student/ica
                            </Header.Subheader>
                        </Header>
                    </Segment>

                    <Segment>
                        {this.getDataToRender().length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={9} >
                                            <div style={{paddingLeft: '30px'}}>
                                                <SearchTableData data={this.state.data} getResults={this.getResults} filterItem={['studyProgramBasicName', 'description', 'enrollmentTerms', 'name', 'department']} />
                                            </div>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={2}>Odsjek</Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2}>Studijski program / implementacija</Table.HeaderCell>
                                        <Table.HeaderCell width="2">Napomena</Table.HeaderCell>
                                        <Table.HeaderCell width="2"><Header as="h4">
                                            <Header.Content>
                                                Trajanje
                                                <Header.Subheader>(godine / semestri)</Header.Subheader>
                                            </Header.Content>
                                        </Header></Table.HeaderCell>
                                        <Table.HeaderCell colSpan={2} width="3">Uslovi upisa</Table.HeaderCell>
                                        <Table.HeaderCell width="2">
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {this.getDataToRender().map((el, index) =>
                                    (<Table.Row key={index}>
                                        <Table.Cell colSpan={2} verticalAlign="middle">
                                            {el.department}
                                        </Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle">
                                            <span><b>{el.studyProgramBasicName !== '-' ? el.studyProgramBasicName : ''}</b></span> {el.studyProgramBasicName !== '-' ? '/ ' + el.name : el.name}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle">
                                            {el.description}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" width="2">
                                            {el.durationYear} /  {el.durationSemester}
                                        </Table.Cell>
                                        <Table.Cell colSpan={2} verticalAlign="middle" width="3">
                                            {el.enrollmentTerms}
                                        </Table.Cell>
                                        <Table.Cell textAlign="center" verticalAlign="middle" width="2">
                                            {this.state.addIndexMode === index ?
                                                <div>
                                                    <h4>Unesite broj indexa:</h4>
                                                    <Form noValidate>
                                                        <Form.Field
                                                            control={Input}
                                                            required
                                                            value={this.state.indexNumber}
                                                            onChange={(e) => this.setState({ indexNumber: e.target.value })}
                                                            name="indexNumber"
                                                            placeholder="Broj indexa"
                                                            error={this.state.indexNumberErr}
                                                        />
                                                        <Popup
                                                            content="Potvrdi"
                                                            position="top center"
                                                            trigger={<Button color="blue" circular icon="check"onClick={this.addIndex}></Button>}
                                                        ></Popup>
                                                    </Form>
                                                </div>
                                                : this.state.confirmation === index ?
                                                    <div>
                                                        <h4>Jeste li sigurni?</h4>
                                                        <Button.Group>
                                                            <Button
                                                                basic="true"
                                                                color="blue"
                                                                onClick={() => { this.enrollStudent(el.id, index); }}
                                                            > DA</Button>
                                                            <Button
                                                                basic="true"
                                                                color="red"
                                                                onClick={() => { this.setState({ confirmation: false }); }}
                                                            >  NE

                                                            </Button>
                                                        </Button.Group></div>
                                                    : <Popup
                                                        content="Upiši studenta"
                                                        position="top center"
                                                        trigger={
                                                            <Button
                                                                basic="true"
                                                                color="blue"
                                                                icon="sign-in alternate"
                                                                circular
                                                                size="small"
                                                                onClick={
                                                                    () => {
                                                                        this.setState({ confirmation: index });
                                                                    }
                                                                }
                                                            ></Button>}
                                                    >
                                                    </Popup>}
                                        </Table.Cell>
                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                            : this.state.showFiltersOnButton ?
                                <NoFilterDataMessage />
                                : <NoDataMessage />
                        }
                    </Segment>
                    <ToastContainer hideProgressBar />
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentSPEnroll.js